import Box from 'projects/libs/core-components/Box/Box';
import { Space } from 'projects/libs/core-components/spaces';
import { ResponsiveProp } from 'projects/libs/utils/responsiveProps';
import React, { Children, ReactNode } from 'react';
import styled from 'styled-components';

interface Props {
    children: ReactNode;
    space: ResponsiveProp<Space>;
}

const BoxItem = styled(Box)`
    :last-child {
        padding-bottom: 0;
    }
`;

export default function Stack({ children, space }: Props) {
    const stackItems = Children.toArray(children);

    if (stackItems.length <= 1) {
        return <>{stackItems}</>;
    }

    return (
        <Box>
            {stackItems.map((child, index) => (
                <BoxItem key={index} paddingBottom={space}>
                    {child}
                </BoxItem>
            ))}
        </Box>
    );
}
